export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // check

  return true
};